import { GeoPoint } from "firebase/firestore";
import { geohashForLocation } from "geofire-common";

// Utility function to generate geohash from GeoPoint
export const generateGeohash = (location: GeoPoint): string => {
  return geohashForLocation([location.latitude, location.longitude]);
};
